




































































































































































































































































































































import Vue from 'vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import moment from 'moment'
import { PROJECT_ASSISTANT_CREATE_PROJECT, PROJECT_ASSISTANT_FETCH_START } from '@/store/action-types'
import {
  CodeBezeichnungItem, CreateProjectResponse, EmployeeInfoItem,
  StartAssistantResponse,
  WertIdBezeichnungItem
} from '@/types/service-response'
import CreateProjectAddressSearch from '@/components/project/CreateProjectAddressSearch.vue'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import { CreateProjectPayload } from '@/types/payload'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  stepper: number
  scrollHeight: string

  prozessartList: CodeBezeichnungItem[]
  profitCenterList: CodeBezeichnungItem[]
  eingangviaList: WertIdBezeichnungItem[]
  lieferungList: CodeBezeichnungItem[]
  lieferungAbAnList: CodeBezeichnungItem[]
  zahlungList: CodeBezeichnungItem[]
  versandList: CodeBezeichnungItem[]
  sachbearbeiterList: EmployeeInfoItem[]

  valid1: boolean
  addressId: number | null
  address: string | null
  showSearchDialog: boolean
  menu1: boolean
  menu2: boolean
  projectDate: string
  projectDateFormatted: string
  referenceDate: string
  referenceDateFormatted: string
  dateRules: Array<Function>
  rules: Array<Function>
  prozessart: number | null
  profitCenter: number | null
  titel: string | null
  ihreReferenz: string | null
  eingangvia: number | null

  valid2: boolean
  lieferung: number | null
  lieferungAbAn: number | null
  zahlung: number | null
  versand: number | null
  unsereReferenz: number | null
  sachbearbeiter: number | null
}

export default Vue.extend({
  name: 'CreateProjectAssistant',

  components: {
    ProgressCircular,
    CreateProjectAddressSearch
  },

  props: {
    showDialog: Boolean
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      stepper: 1,
      scrollHeight: '',

      prozessartList: [],
      profitCenterList: [],
      eingangviaList: [],
      lieferungList: [],
      lieferungAbAnList: [],
      zahlungList: [],
      versandList: [],
      sachbearbeiterList: [],

      valid1: true,
      addressId: null,
      address: null,
      showSearchDialog: false,
      menu1: false,
      menu2: false,
      projectDate: '',
      projectDateFormatted: '',
      referenceDate: '',
      referenceDateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],
      rules: [(value: any): boolean | string => !!value || ''],
      prozessart: null,
      profitCenter: null,
      titel: null,
      ihreReferenz: null,
      eingangvia: null,

      valid2: true,
      lieferung: null,
      lieferungAbAn: null,
      zahlung: null,
      versand: null,
      unsereReferenz: null,
      sachbearbeiter: null
    }
  },

  watch: {
    stepper (newVal: number): void {
      if(newVal && newVal === 1) {
        setTimeout(() => {
          const prozessArtField: any = this.$refs['prozessArtField']
          if (prozessArtField) {
            prozessArtField.focus()
          }
        }, 0)
      } else if(newVal && newVal === 2) {
        setTimeout(() => {
          const lieferungField: any = this.$refs['lieferungField']
          if (lieferungField) {
            lieferungField.focus()
          }
        }, 0)
      }
    },

    projectDateFormatted (newVal: string): void {
      if(newVal) {
        this.projectDate = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.projectDate = ''
      }
    },

    referenceDateFormatted (newVal: string): void {
      if(newVal) {
        this.referenceDate = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.referenceDate = ''
      }
    }
  },

  computed: {
    currentUserId (): number | undefined {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isNextStepDisabled (): boolean {
      return this.stepper !== 1 || !this.valid1
    },

    isFinishDisabled (): boolean {
      return this.stepper !== 2 || !this.valid2
    }
  },

  methods: {
    onResize (): void {
      this.scrollHeight = `max-height: calc(100vh - 190px)`
    },

    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
      setTimeout(() => {
        const prozessArtField: any = this.$refs['prozessArtField']
        if (prozessArtField) {
          prozessArtField.focus()
        }
      }, 0)
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.id
    },

    selectedAddressEmployee (data: SearchAddressEmployee): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.adressID
    },

    onProjectDateChange (date: string): void {
      this.projectDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onReferenceDateChange (date: string): void {
      this.referenceDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onFocusProject (): void {
      setTimeout(() => {
        if(!this.menu1) {
          this.menu1 = true
        }
      }, 100)
    },

    onBlurProject (): void {
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFocusReference (): void {
      setTimeout(() => {
        if(!this.menu2) {
          this.menu2 = true
        }
      }, 100)
    },

    onBlurReference (): void {
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },


    onBackClick (): void {
      this.stepper = this.stepper - 1
    },

    onForwardClick (): void {
      this.stepper = this.stepper + 1
    },

    onFinishClick (): void {
      this.createProject()
    },

    onCloseDialog (): void {
      this.$emit('onCloseDialog')
    },

    async createProject (): Promise<void> {
      const payload: CreateProjectPayload = {
        Titel: this.titel,
        IhreReferenz: this.ihreReferenz,
        ProjektDatum: this.projectDate,
        ReferenzTermin: this.referenceDate,
        Sprache: this.selectedLanguageId,
        AdresseID: this.addressId!,
        Prozessart: this.prozessart!,
        ProfitCenter: this.profitCenter!,
        Eingangvia: this.eingangvia,
        Lieferung: this.lieferung!,
        LieferungAbAn: this.lieferungAbAn!,
        Zahlung: this.zahlung!,
        Versand: this.versand!,
        UnsereReferenz: this.unsereReferenz!,
        Sachbearbeiter: this.sachbearbeiter!
      }

      try {
        this.loading = true
        const response: CreateProjectResponse = await this.$store.dispatch(PROJECT_ASSISTANT_CREATE_PROJECT, payload)
        this.loading = false
        if(!response.IsError && response.ProjectID) {
          this.$emit('createdProject', response.ProjectID)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: StartAssistantResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_START)
        this.loading = false
        if(!response.IsError) {
          this.prozessartList = response.Prozessart
          this.profitCenterList = response.ProfitCenter
          this.eingangviaList = response.Eingangvia
          this.lieferungList = response.Lieferung
          this.lieferungAbAnList = response.LieferungAbAn
          this.zahlungList = response.Zahlung
          this.versandList = response.Versand
          this.sachbearbeiterList = response.Sachbearbeiter
          this.lieferung = response.Defaults.Lieferung
          this.lieferungAbAn = response.Defaults.LieferungAbAn
          this.zahlung = response.Defaults.Zahlung
          this.versand = response.Defaults.Versand

          this.profitCenter = this.profitCenterList && this.profitCenterList[0] ? this.profitCenterList[0].ID : null
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
      }
    }
  },

  mounted (): void {
    this.projectDate = moment().format('YYYY-MM-DD')
    this.projectDateFormatted = moment().format('DD.MM.YYYY')
    this.referenceDate = moment().format('YYYY-MM-DD')
    this.referenceDateFormatted = moment().format('DD.MM.YYYY')
    this.unsereReferenz = this.currentUserId ? this.currentUserId : null
    this.sachbearbeiter = this.currentUserId ? this.currentUserId : null
    this.showSearchDialog = true
    this.fetchData()
  }
})
